var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsDownloadBoxOutlineBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#DB536A;}\n\t.st2{fill:#E0301E;}\n\t.st3{fill:#D04A02;}\n\t.st4{fill:#464646;}\n\t.st5{fill:#7D7D7D;}\n\t.st6{fill:#2D2D2D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-v2_8_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download_8_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_7_",
    d: "M49.8,67.5L49.8,67.5l0-5.4L38,50.3c-0.9-0.9-2.3-0.9-3.2,0c-0.9,0.9-0.9,2.3,0,3.2L52,70.7 l17.2-17.2c0.9-0.9,0.9-2.3,0-3.2c-0.9-0.9-2.3-0.9-3.2,0L54.3,62.1V36h-4.5v26.1V67.5z M20.5,85.5h63c2.5,0,4.5-2,4.5-4.5V31.5 H54.3V36h29.3v45h-63V36h29.3v-4.5H16V81C16,83.5,18,85.5,20.5,85.5z M49.8,31.5h4.5v-18h-4.5V31.5z M49.8,36h4.5v-4.5h-4.5V36z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsDownloadBoxOutlineBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_DownloadBox_Outline_Black_RGB.02360a7e43ee7a9150d5da4660d84a4d.svg";
export { ForwardRef as ReactComponent };